import React, { useEffect, useState } from "react";
import useWindowSize from "../../hooks/windowScreenHook";
import Hero from "../Hero/Hero";

const Banner = ({ sectionData, handleDetails, onItemClick, isGenre }) => {
  const [bannerItem, setBannerItem] = useState(null);
  const { width } = useWindowSize();

  const normalizedSectionData = Array.isArray(sectionData)
    ? sectionData
    : sectionData?.related_content
      ? [{ type: "carousel", items: sectionData.related_content }]
      : [];

  useEffect(() => {
    const carouselItem = normalizedSectionData.find(
      (el) => el?.type?.toLowerCase() === "carousel"
    );
    if (carouselItem && Array.isArray(carouselItem.items) && carouselItem.items.length > 0) {
      setBannerItem(carouselItem.items[0]);
    } else {
      setBannerItem(null);
    }
  }, [normalizedSectionData]);

  if (!bannerItem) return null;

 const handleClick = () => {
  const clickHandler = handleDetails || onItemClick;
  if (!clickHandler) return;
  const slugOrId = bannerItem.slug || bannerItem.id;
  const typeSlug = bannerItem.content_type
    ? bannerItem.content_type.toLowerCase().replace(/\s+/g, "-")
    : "creators";
  clickHandler(slugOrId, typeSlug); // Pass typeSlug
};


  return (
    <div className="static-banner">
      <Hero
        title={bannerItem.name}
        description={bannerItem.description || bannerItem.channel_description}
        posterUrl={
          bannerItem.thumbnail_image ||
          bannerItem.landscape ||
          bannerItem.channel_banner ||
          bannerItem.portrait
        }
        data={bannerItem.slug || bannerItem.id}
        handleDetails={handleClick}
        year={bannerItem.uploadedYear}
        genre={bannerItem.genres?.map((g) => g.name).join(", ")}
        rating={bannerItem.rating}
        access={bannerItem.access}
      />
    </div>
  );
};

export default Banner;
